import animationManager, {
  makeSequence,
} from "../../../../services/animation-manager";
import {
  mainDrawerHTMLSelector,
  resetToFarRight,
  RouteChangeCallbacks,
} from "./common";

export function registerTransitionSequence(
  { onSlideMainDrawerOutEnd }: RouteChangeCallbacks,
  direction: "normal" | "reverse" = "normal",
): void {
  animationManager.register(
    `transitionSameLevelDoubleDrawer${direction === "reverse" ? "Reverse" : ""}`,
    makeSequence([
      [
        {
          elementSelector: mainDrawerHTMLSelector,
          animation: {
            className:
              direction === "reverse"
                ? `translate-backward-animation-out`
                : `translate-forward-animation-out`,
            cleanUpAfterAnimation: resetToFarRight,
          },
          onEnd: onSlideMainDrawerOutEnd,
        },
      ],
      [
        {
          elementSelector: mainDrawerHTMLSelector,
          animation: {
            className:
              direction === "reverse"
                ? `translate-backward-animation-in`
                : `translate-forward-animation-in`,
            cleanUpBeforeAnimation: (element) => {
              element.style.translate = "";
              element.style.position = "";
            },
          },
        },
      ],
    ]),
  );
}
